import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "hooks/useQuery";
import { CourseService } from "services/courseService";

const ApplyPublicationButton = () => {
  const { t } = useTranslation();

  // Fetch active course for the apply button
  const { data: activeCourseId, loading: courseLoading } = useQuery({
    queryFn: async () => {
      return await CourseService.getActiveCourse();
    },
  });

  // Don't render if loading or no active course
  if (courseLoading || !activeCourseId) {
    return null;
  }

  return (
    <div className="mb-4">
      <div
        className="card text-center"
        style={{
          border: 'none',
          borderRadius: '12px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07)',
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-3px)';
          e.currentTarget.style.boxShadow = '0 8px 16px rgba(102, 126, 234, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.07)';
        }}
      >
        <div className="card-body p-4">
          <div className="d-flex align-items-center justify-content-between">
            <div className="text-start text-white">
              <h5 className="mb-2 fw-bold">{t("Dashboard:applyForPublication")}</h5>
              <p className="mb-0 opacity-90" style={{ fontSize: '0.95rem' }}>
                {t("Dashboard:applyForPublicationDesc")}
              </p>
            </div>
            <Link
              to={`/course/${activeCourseId}`}
              className="btn btn-light fw-bold px-4 py-2"
              style={{
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                whiteSpace: 'nowrap',
              }}
            >
              <i className="bi bi-plus-circle mx-2"></i>
              {t("Dashboard:applyNow")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplyPublicationButton;